<ng-template #neoGlyph>
  <!-- Neo's network mark, as on the full Neo screen; solid fills so repeated copies need no shared ids. -->
  <svg class="neo-glyph" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
    <line x1="28" y1="28" x2="28" y2="92" />
    <line x1="28" y1="28" x2="92" y2="92" />
    <line x1="92" y1="28" x2="92" y2="92" />
    <circle cx="28" cy="28" r="12" fill="#222861" />
    <circle cx="28" cy="92" r="11" fill="#6b5fa8" />
    <circle cx="92" cy="28" r="11" fill="#b04aa0" />
    <circle cx="92" cy="92" r="11" fill="#b04aa0" />
  </svg>
</ng-template>

<div class="thread" #thread (scroll)="onScroll()" role="log" aria-live="polite" aria-label="Neo conversation">
  <div class="intro" *ngIf="!available">
    <span class="intro-mark"><ng-container *ngTemplateOutlet="neoGlyph"></ng-container></span>
    <p>Neo isn't available here</p>
    <span>Neo needs your portal sign-in. Join this meeting from the portal to ask Neo about your data.</span>
  </div>

  <div class="intro" *ngIf="available && !messages.length">
    <span class="intro-mark"><ng-container *ngTemplateOutlet="neoGlyph"></ng-container></span>
    <p>Ask Neo</p>
    <span>Ask Neo about your data. Only you can see this conversation — not others in the meeting.</span>
  </div>

  <div class="stack" *ngIf="messages.length">
    <ng-container *ngFor="let message of messages; trackBy: trackMessage">
      <div class="turn turn-user" *ngIf="message.from === 'user'">
        <div class="bubble">{{ message.text }}</div>
        <span
          class="user-avatar"
          [style.background]="userAvatar.background"
          [style.color]="userAvatar.color"
          aria-hidden="true">{{ userInitials }}</span>
      </div>

      <div class="turn turn-neo" *ngIf="message.from === 'neo'">
        <span class="neo-avatar"><ng-container *ngTemplateOutlet="neoGlyph"></ng-container></span>
        <div class="neo-body">
          <div class="neo-head">
            <span class="neo-name">Neo</span>
            <span class="neo-role">your data analyst</span>
          </div>

          <div class="answer is-pending" *ngIf="message.state === 'pending'">
            <svg class="spinner" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <!-- Rays clockwise from 12 o'clock; the stylesheet fades them into a trail. -->
              <line x1="12" y1="2.5" x2="12" y2="6.5" />
              <line x1="18.7" y1="5.3" x2="15.9" y2="8.1" />
              <line x1="21.5" y1="12" x2="17.5" y2="12" />
              <line x1="18.7" y1="18.7" x2="15.9" y2="15.9" />
              <line x1="12" y1="21.5" x2="12" y2="17.5" />
              <line x1="5.3" y1="18.7" x2="8.1" y2="15.9" />
              <line x1="2.5" y1="12" x2="6.5" y2="12" />
              <line x1="5.3" y1="5.3" x2="8.1" y2="8.1" />
            </svg>
            <span>{{ message.text }}</span>
          </div>

          <div class="answer" *ngIf="message.state === 'answer'">{{ message.text }}</div>

          <div class="answer is-note" *ngIf="message.state === 'note'">{{ message.text }}</div>

          <div class="answer is-error" *ngIf="message.state === 'error'">
            <span>{{ message.text }}</span>
            <button type="button" class="retry" [disabled]="busy" (click)="retry(message)">Try again</button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<form class="compose" [class.off]="!available" (ngSubmit)="submit()">
  <textarea
    #box
    name="draft"
    rows="2"
    [(ngModel)]="draft"
    [disabled]="!available"
    [attr.maxlength]="maxChars"
    (keydown)="onKeydown($event)"
    placeholder="Ask Neo…"
    aria-label="Ask Neo"></textarea>
  <div class="compose-bar">
    <button
      type="submit"
      class="send"
      [disabled]="!canSend"
      [attr.aria-label]="busy ? 'Neo is answering' : 'Send to Neo'"
      [matTooltip]="busy ? 'Neo is answering…' : 'Send (Enter)'">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M22 2 11 13" />
        <path d="M22 2 15 22l-4-9-9-4 20-7z" />
      </svg>
    </button>
  </div>
</form>
